import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useCupon } from "../../../../context/CuponContext";

export default function EliminarCupon() {
  const {
    cuponSeleccionado,
    modalOpenEliminarCupon,
    handleOpenEliminarCupon,
    handleSubmitEliminarCupon,
  } = useCupon();

  return (
    <MeditocModal
      size="small"
      align="center"
      title="Eliminar cupón"
      open={modalOpenEliminarCupon}
      setopen={handleOpenEliminarCupon}
      okfunc={handleSubmitEliminarCupon}
    >
      <Grid container spacing={1} className="center">
        <Grid item xs={12}>
          <Typography paragraph align="center">
            ¿Desea eliminar el siguiente cupón?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <MeditocInfoField
            label="Código de cupón:"
            value={cuponSeleccionado.fsCodigo}
          />
        </Grid>
        <Grid item xs={12}>
          <MeditocInfoField
            label="Tipo de cupón:"
            value={cuponSeleccionado.fsDescripcionCategoria}
          />
        </Grid>
        {cuponSeleccionado.sMontoDescuento && (
          <Grid item xs={12}>
            <MeditocInfoField
              label="Monto de descuento:"
              value={cuponSeleccionado.sMontoDescuento}
            />
          </Grid>
        )}
        {cuponSeleccionado.sPorcentajeDescuento && (
          <Grid item xs={12}>
            <MeditocInfoField
              label="Porcentaje de descuento:"
              value={cuponSeleccionado.sPorcentajeDescuento}
            />
          </Grid>
        )}
      </Grid>
    </MeditocModal>
  );
}
